/* ==========================================================================
   BLANKS COMPARATOR — Standalone JS (no external dependencies)
   ========================================================================== */
(function () {
  'use strict';

  if (window.__blanksComparatorInit) return;
  window.__blanksComparatorInit = true;

  /* --- Constants --- */
  var COLORS = ['#4197CB', '#31AF54', '#FFB74A', '#AA2826', '#9B59B6', '#E91E63'];
  var MAX_SELECTIONS = 5;
  var ZOOM_MIN = 0.5;
  var ZOOM_MAX = 3;
  var ZOOM_STEP = 0.25;
  var STORAGE_KEY = 'rodhouse:comparator:selected';

  /* --- State --- */
  var allBlanks = [];
  var selected = [];    // { id, title, datas, color, activeIndexes: [] }
  var zoomLevel = 1;
  var dataLoaded = false;
  var focusedIndex = -1;
  var stateRestored = false;

  /* --- Persistence --- */
  function saveState() {
    try {
      var minimal = selected.map(function (s) {
        return { id: s.id, color: s.color, activeIndexes: s.activeIndexes.slice() };
      });
      localStorage.setItem(STORAGE_KEY, JSON.stringify(minimal));
    } catch (e) { /* quota exceeded or unavailable */ }
  }

  function restoreState() {
    if (stateRestored) return;
    stateRestored = true;
    if (selected.length > 0) return;

    var raw;
    try { raw = localStorage.getItem(STORAGE_KEY); }
    catch (e) { return; }
    if (!raw) return;

    var stored;
    try { stored = JSON.parse(raw); }
    catch (e) { return; }
    if (!Array.isArray(stored) || stored.length === 0) return;

    stored.forEach(function (s) {
      if (!s || selected.length >= MAX_SELECTIONS) return;
      var idStr = String(s.id);
      var blank = allBlanks.find(function (b) { return b.id === idStr; });
      if (!blank) return;
      var datas = blank.datas || [];
      var activeIndexes;
      if (Array.isArray(s.activeIndexes)) {
        activeIndexes = s.activeIndexes.filter(function (i) {
          return typeof i === 'number' && i >= 0 && i < datas.length;
        });
      } else {
        activeIndexes = datas.map(function (_, i) { return i; });
      }
      var color = (typeof s.color === 'string' && COLORS.indexOf(s.color) !== -1)
        ? s.color
        : getNextColor();
      selected.push({
        id: blank.id,
        title: blank.title,
        datas: datas,
        color: color,
        activeIndexes: activeIndexes
      });
    });

    if (selected.length > 0) {
      renderTags();
      renderResults();
      updateOverlays();
      updateVisibility();
      saveState(); // re-sync (drops stale ids that no longer exist in JSON)
    }
  }

  /* --- DOM helpers --- */
  function getDialog() { return document.getElementById('blanks-comparator'); }
  function qs(sel) { var d = getDialog(); return d ? d.querySelector(sel) : null; }

  function getSearchInput() { return qs('[data-comparator-search]'); }
  function getDropdown() { return qs('[data-comparator-dropdown]'); }
  function getTagsContainer() { return qs('[data-comparator-tags]'); }
  function getEmptyState() { return qs('[data-comparator-empty]'); }
  function getViewport() { return qs('[data-comparator-viewport]'); }
  function getImageWrap() { return qs('[data-comparator-image-wrap]'); }
  function getOverlaysContainer() { return qs('[data-comparator-overlays]'); }
  function getResultsContainer() { return qs('[data-comparator-results]'); }

  /* --- Color filter presets (hex → CSS filter approximation) --- */
  var COLOR_FILTERS = {
    '#4197CB': 'brightness(0) saturate(100%) invert(52%) sepia(60%) saturate(450%) hue-rotate(168deg) brightness(95%) contrast(90%)',
    '#31AF54': 'brightness(0) saturate(100%) invert(55%) sepia(60%) saturate(500%) hue-rotate(100deg) brightness(92%) contrast(88%)',
    '#FFB74A': 'brightness(0) saturate(100%) invert(72%) sepia(60%) saturate(600%) hue-rotate(5deg) brightness(102%) contrast(95%)',
    '#AA2826': 'brightness(0) saturate(100%) invert(18%) sepia(80%) saturate(3000%) hue-rotate(350deg) brightness(90%) contrast(95%)',
    '#9B59B6': 'brightness(0) saturate(100%) invert(35%) sepia(50%) saturate(600%) hue-rotate(250deg) brightness(90%) contrast(90%)',
    '#E91E63': 'brightness(0) saturate(100%) invert(22%) sepia(90%) saturate(4000%) hue-rotate(330deg) brightness(95%) contrast(95%)'
  };

  /* --- Data loading (static JSON asset; shared promise across instances) --- */
  function loadData(callback) {
    if (dataLoaded) { if (callback) callback(); return; }

    var url = window.__comparatorDataUrl;
    if (!url) {
      console.error('Blanks comparator: window.__comparatorDataUrl is not set');
      return;
    }

    if (!window.__comparatorDataPromise) {
      window.__comparatorDataPromise = fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        });
    }

    window.__comparatorDataPromise
      .then(function (raw) {
        allBlanks = raw.map(function (b) { b.id = String(b.id); return b; });
        dataLoaded = true;
        restoreState();
        if (callback) callback();
      })
      .catch(function (err) {
        console.error('Blanks comparator: failed to load data', err);
      });
  }

  /* --- Dropdown rendering --- */
  function showDropdown() {
    var input = getSearchInput();
    var dropdown = getDropdown();
    if (!input || !dropdown) return;

    var query = input.value.trim().toLowerCase();
    var filtered = allBlanks.filter(function (b) {
      return query === '' || b.title.toLowerCase().indexOf(query) !== -1;
    });

    dropdown.innerHTML = '';
    focusedIndex = -1;

    if (filtered.length === 0) {
      var emptyLi = document.createElement('li');
      emptyLi.className = 'blanks-comparator__dropdown-empty';
      emptyLi.textContent = 'Aucun résultat';
      dropdown.appendChild(emptyLi);
    } else {
      filtered.forEach(function (blank) {
        var li = document.createElement('li');
        li.className = 'blanks-comparator__dropdown-item';
        li.setAttribute('data-blank-id', blank.id);
        li.textContent = blank.title;

        var isSelected = selected.some(function (s) { return s.id === blank.id; });
        if (isSelected) li.classList.add('is-selected');

        dropdown.appendChild(li);
      });
    }

    dropdown.hidden = false;
  }

  function hideDropdown() {
    var dropdown = getDropdown();
    if (dropdown) {
      dropdown.hidden = true;
      focusedIndex = -1;
    }
  }

  /* --- Selection --- */
  function getNextColor() {
    var usedColors = selected.map(function (s) { return s.color; });
    for (var i = 0; i < COLORS.length; i++) {
      if (usedColors.indexOf(COLORS[i]) === -1) return COLORS[i];
    }
    return COLORS[0];
  }

  function selectBlank(blankId) {
    if (selected.length >= MAX_SELECTIONS) return;
    if (selected.some(function (s) { return s.id === blankId; })) return;

    var blank = allBlanks.find(function (b) { return b.id === blankId; });
    if (!blank) return;

    var color = getNextColor();
    var activeIndexes = [];
    if (blank.datas) {
      for (var i = 0; i < blank.datas.length; i++) activeIndexes.push(i);
    }

    selected.push({
      id: blank.id,
      title: blank.title,
      datas: blank.datas || [],
      color: color,
      activeIndexes: activeIndexes
    });

    renderTags();
    renderResults();
    updateOverlays();
    updateVisibility();
    saveState();
    showDropdown(); // refresh checked state
  }

  function removeBlank(blankId) {
    selected = selected.filter(function (s) { return s.id !== blankId; });
    renderTags();
    renderResults();
    updateOverlays();
    updateVisibility();
    saveState();

    var dropdown = getDropdown();
    if (dropdown && !dropdown.hidden) showDropdown();
  }

  /* --- Visibility toggle --- */
  function updateVisibility() {
    var empty = getEmptyState();
    var viewport = getViewport();
    var results = getResultsContainer();
    var hasSelection = selected.length > 0;

    if (empty) empty.hidden = hasSelection;
    if (viewport) viewport.hidden = !hasSelection;
    if (results) results.hidden = !hasSelection;
  }

  /* --- Tags --- */
  function renderTags() {
    var container = getTagsContainer();
    if (!container) return;

    container.innerHTML = '';
    selected.forEach(function (item) {
      var tag = document.createElement('span');
      tag.className = 'blanks-comparator__tag';
      tag.style.setProperty('--tag-color', item.color);

      var name = document.createElement('span');
      name.className = 'blanks-comparator__tag-name';
      name.textContent = item.title;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'blanks-comparator__tag-remove';
      btn.setAttribute('aria-label', 'Retirer ' + item.title);
      btn.setAttribute('data-remove-blank', item.id);
      btn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>';

      tag.appendChild(name);
      tag.appendChild(btn);
      container.appendChild(tag);
    });
  }

  /* --- Result cards --- */
  function renderResults() {
    var container = getResultsContainer();
    if (!container) return;

    container.innerHTML = '';
    selected.forEach(function (item) {
      var card = document.createElement('div');
      card.className = 'blanks-comparator__card';
      card.style.setProperty('--card-color', item.color);

      var title = document.createElement('h4');
      title.className = 'blanks-comparator__card-title';
      title.textContent = item.title;
      card.appendChild(title);

      var chips = document.createElement('div');
      chips.className = 'blanks-comparator__card-chips';

      item.datas.forEach(function (d, idx) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'blanks-comparator__chip';
        chip.textContent = d.value + ' g';
        chip.setAttribute('data-chip-blank', item.id);
        chip.setAttribute('data-chip-index', idx);
        chip.style.setProperty('--chip-color', item.color);
        chip.style.setProperty('--chip-bg', hexToRgba(item.color, 0.12));

        if (item.activeIndexes.indexOf(idx) !== -1) {
          chip.classList.add('is-active');
        }

        chips.appendChild(chip);
      });

      card.appendChild(chips);
      container.appendChild(card);
    });
  }

  /* --- Image overlays --- */
  function updateOverlays() {
    var container = getOverlaysContainer();
    if (!container) return;

    container.innerHTML = '';
    selected.forEach(function (item) {
      item.datas.forEach(function (d, idx) {
        if (item.activeIndexes.indexOf(idx) === -1) return;

        var img = document.createElement('img');
        img.className = 'blanks-comparator__overlay-img';
        img.src = d.image;
        img.alt = item.title + ' - ' + d.value + 'g';
        img.loading = 'lazy';
        img.draggable = false;
        img.setAttribute('data-overlay-blank', item.id);
        img.setAttribute('data-overlay-index', idx);

        var filter = COLOR_FILTERS[item.color];
        if (filter) img.style.filter = filter;

        container.appendChild(img);
      });
    });
  }

  function toggleChip(blankId, index) {
    var item = selected.find(function (s) { return s.id === blankId; });
    if (!item) return;

    var pos = item.activeIndexes.indexOf(index);
    if (pos !== -1) {
      item.activeIndexes.splice(pos, 1);
    } else {
      item.activeIndexes.push(index);
    }

    renderResults();
    updateOverlays();
    saveState();
  }

  /* --- Zoom --- */
  function setZoom(level) {
    zoomLevel = Math.max(ZOOM_MIN, Math.min(ZOOM_MAX, level));
    var wrap = getImageWrap();
    if (wrap) {
      wrap.style.transform = 'scale(' + zoomLevel + ')';
    }
  }

  /* --- Pan (drag) support --- */
  var panState = { active: false, startX: 0, startY: 0, scrollLeft: 0, scrollTop: 0 };

  function initPan(viewport) {
    if (!viewport) return;

    viewport.addEventListener('mousedown', function (e) {
      if (e.target.closest('.blanks-comparator__zoom-controls')) return;
      panState.active = true;
      panState.startX = e.pageX - viewport.offsetLeft;
      panState.startY = e.pageY - viewport.offsetTop;
      panState.scrollLeft = viewport.scrollLeft;
      panState.scrollTop = viewport.scrollTop;
      var wrap = getImageWrap();
      if (wrap) wrap.classList.add('is-dragging');
    });

    viewport.addEventListener('mouseleave', endPan);
    viewport.addEventListener('mouseup', endPan);

    viewport.addEventListener('mousemove', function (e) {
      if (!panState.active) return;
      e.preventDefault();
      var x = e.pageX - viewport.offsetLeft;
      var y = e.pageY - viewport.offsetTop;
      viewport.scrollLeft = panState.scrollLeft - (x - panState.startX);
      viewport.scrollTop = panState.scrollTop - (y - panState.startY);
    });
  }

  function endPan() {
    panState.active = false;
    var wrap = getImageWrap();
    if (wrap) wrap.classList.remove('is-dragging');
  }

  /* --- Scroll lock --- */
  var comparatorScrollY = 0;

  function lockComparatorScroll() {
    comparatorScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + comparatorScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }

  function unlockComparatorScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, comparatorScrollY);
  }

  /* --- Animated close helper --- */
  var CLOSE_DURATION = 300;

  function closeComparator() {
    var dialog = getDialog();
    if (!dialog || !dialog.open || dialog.hasAttribute('data-closing')) return;
    dialog.setAttribute('data-closing', '');
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      dialog.removeAttribute('data-closing');
      dialog.close();
      return;
    }
    setTimeout(function () {
      dialog.removeAttribute('data-closing');
      dialog.close();
    }, CLOSE_DURATION);
  }

  /* --- Global open function --- */
  window.openComparatorModal = function (preselectId) {
    var dialog = getDialog();
    if (!dialog || dialog.open) return;

    // Close mobile nav if open
    var mobileNav = document.getElementById('header-sidebar-menu');
    if (mobileNav && mobileNav.open) {
      mobileNav.close();
      document.body.classList.remove('mobile-nav-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
    }

    // Close any open desktop mega menu
    document.querySelectorAll('header details[open]').forEach(function(d) {
      d.removeAttribute('open');
    });

    // Open dialog + lock scroll
    dialog.showModal();
    lockComparatorScroll();

    loadData(function () {
      if (!preselectId) return;
      var idStr = String(preselectId);
      if (selected.some(function (s) { return s.id === idStr; })) return;
      if (!allBlanks.some(function (b) { return b.id === idStr; })) return;
      selectBlank(idStr);
    });
  };

  /* --- Close: button [data-overlay-close] inside comparator --- */
  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-overlay-close]');
    if (!closer) return;
    var dialog = closer.closest('dialog');
    if (dialog !== getDialog()) return;
    closeComparator();
  });

  /* --- Close: backdrop click --- */
  document.addEventListener('click', function (e) {
    var dialog = getDialog();
    if (e.target !== dialog || !dialog || !dialog.open) return;
    var panel = dialog.querySelector('.overlay-drawer__panel');
    if (!panel) return;
    var panelRect = panel.getBoundingClientRect();
    var isOutside =
      e.clientX < panelRect.left ||
      e.clientX > panelRect.right ||
      e.clientY < panelRect.top ||
      e.clientY > panelRect.bottom;
    if (isOutside) closeComparator();
  });

  /* --- Close: Escape key --- */
  document.addEventListener('cancel', function (e) {
    if (e.target !== getDialog()) return;
    e.preventDefault();
    closeComparator();
  }, true);

  /* --- Unlock scroll when dialog closes --- */
  document.addEventListener('close', function (e) {
    if (e.target === getDialog()) {
      unlockComparatorScroll();
    }
  }, true);

  /* --- Drag-to-scroll on result cards --- */
  (function () {
    var container = null;
    var isDragging = false;
    var startX = 0;
    var scrollLeft = 0;

    function getResults() {
      if (!container) container = qs('[data-comparator-results]');
      return container;
    }

    document.addEventListener('mousedown', function (e) {
      var el = e.target.closest('.blanks-comparator__results');
      if (!el) return;
      container = el;
      isDragging = true;
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
      el.classList.add('is-dragging');
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging || !container) return;
      e.preventDefault();
      var x = e.pageX - container.offsetLeft;
      container.scrollLeft = scrollLeft - (x - startX);
    });

    document.addEventListener('mouseup', function () {
      if (!isDragging || !container) return;
      isDragging = false;
      container.classList.remove('is-dragging');
    });
  })();

  /* --- Intercept all #comparator links site-wide --- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest(
      'a[href="#comparator"], a[href$="#comparator"], ' +
      'summary[data-url="#comparator"], summary[data-url$="#comparator"]'
    );
    if (!link) return;
    e.preventDefault();
    if (link.tagName === 'SUMMARY') {
      var details = link.closest('details');
      if (details) details.removeAttribute('open');
    }
    var preselectId = link.getAttribute('data-preselect-blank-id');
    window.openComparatorModal(preselectId || null);
  });

  /* --- Hash support (direct URL with #comparator) --- */
  function checkHash() {
    if (window.location.hash === '#comparator') {
      window.openComparatorModal();
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  window.addEventListener('hashchange', checkHash);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkHash);
  } else {
    checkHash();
  }

  /* --- Event delegation --- */
  document.addEventListener('click', function (e) {
    // Dropdown item click
    var dropdownItem = e.target.closest('.blanks-comparator__dropdown-item');
    if (dropdownItem && !dropdownItem.classList.contains('is-selected')) {
      var id = dropdownItem.getAttribute('data-blank-id');
      if (id) selectBlank(id);
      return;
    }

    // Tag remove
    var removeBtn = e.target.closest('[data-remove-blank]');
    if (removeBtn) {
      var blankId = removeBtn.getAttribute('data-remove-blank');
      if (blankId) removeBlank(blankId);
      return;
    }

    // Chip toggle
    var chip = e.target.closest('[data-chip-blank]');
    if (chip) {
      var chipBlankId = chip.getAttribute('data-chip-blank');
      var chipIndex = parseInt(chip.getAttribute('data-chip-index'), 10);
      if (chipBlankId && !isNaN(chipIndex)) toggleChip(chipBlankId, chipIndex);
      return;
    }

    // Zoom controls
    var zoomBtn = e.target.closest('[data-comparator-zoom]');
    if (zoomBtn) {
      var action = zoomBtn.getAttribute('data-comparator-zoom');
      if (action === 'in') setZoom(zoomLevel + ZOOM_STEP);
      else if (action === 'out') setZoom(zoomLevel - ZOOM_STEP);
      else if (action === 'reset') setZoom(1);
      return;
    }

    // Close dropdown when clicking outside
    var dialog = getDialog();
    if (dialog && !e.target.closest('.blanks-comparator__search')) {
      hideDropdown();
    }
  });

  /* --- Search input events --- */
  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-comparator-search]')) {
      showDropdown();
    }
  });

  document.addEventListener('focusin', function (e) {
    if (e.target.matches('[data-comparator-search]')) {
      if (dataLoaded) showDropdown();
      else loadData(function () { showDropdown(); });
    }
  });

  /* --- Keyboard navigation --- */
  document.addEventListener('keydown', function (e) {
    if (!e.target.matches('[data-comparator-search]')) return;

    var dropdown = getDropdown();
    if (!dropdown || dropdown.hidden) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        showDropdown();
        e.preventDefault();
      }
      return;
    }

    var items = dropdown.querySelectorAll('.blanks-comparator__dropdown-item:not(.is-selected)');
    if (!items.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      focusedIndex = Math.min(focusedIndex + 1, items.length - 1);
      updateFocus(items);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      focusedIndex = Math.max(focusedIndex - 1, 0);
      updateFocus(items);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (focusedIndex >= 0 && focusedIndex < items.length) {
        var id = items[focusedIndex].getAttribute('data-blank-id');
        if (id) selectBlank(id);
      }
    } else if (e.key === 'Escape') {
      hideDropdown();
    }
  });

  function updateFocus(items) {
    items.forEach(function (item, i) {
      item.classList.toggle('is-focused', i === focusedIndex);
      if (i === focusedIndex) {
        item.scrollIntoView({ block: 'nearest' });
      }
    });
  }

  /* --- Init pan on viewport when dialog opens --- */
  var panInitialized = false;
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName === 'open') {
        var dialog = getDialog();
        if (dialog && dialog.open && !panInitialized) {
          var viewport = getViewport();
          if (viewport) {
            initPan(viewport);
            panInitialized = true;
          }
        }
      }
    });
  });

  // Start observing once dialog exists
  function startObserving() {
    var dialog = getDialog();
    if (dialog) {
      observer.observe(dialog, { attributes: true });
    } else {
      // Retry after DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          var d = getDialog();
          if (d) observer.observe(d, { attributes: true });
        });
      }
    }
  }

  startObserving();

  /* --- Utility --- */
  function hexToRgba(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  }

})();
